<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M12.0008 13.5003V11.9997C13.1059 11.9997 14.0017 11.1039 14.0017 9.99888C14.0017 8.89385 13.1059 7.99805 12.0008 7.99805C10.8958 7.99805 10 8.89385 10 9.99888"
    stroke="#2A3243" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
  <circle cx="11.9998" cy="11.9998" r="9.00375" stroke="#2A3243" stroke-width="2" stroke-linecap="round"
    stroke-linejoin="round" />
  <path
    d="M12.0002 15.9502C11.9726 15.9502 11.9502 15.9726 11.9502 16.0002C11.9502 16.0278 11.9726 16.0502 12.0002 16.0502C12.0278 16.0502 12.0502 16.0278 12.0502 16.0002C12.0502 15.9726 12.0278 15.9502 12.0002 15.9502"
    stroke="#2A3243" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
</svg>